import clsx from 'clsx'
import { Box, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {}
}))

function ObstacleContent ({ className, ...rest }) {
  const classes = useStyles()
  return (
    <div className={clsx(classes.root, className)}>
      <Typography variant='h6'>Impedimento</Typography>
      <Box my={2}>
        <Typography variant='body1'>
          Vuoi inserire un impedimento?
        </Typography>
      </Box>
    </div>
  )
}
export default ObstacleContent
